import { BaseLookupService } from "../../impl/BaseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { Injectable } from "@angular/core";
import { CubiqWorker } from "shared/cubiq-services/worker/CubiqWorker";
import { Observable } from "rxjs";
import { PrimaryPromiseSet, PromiseSet } from "shared/auth-services";

@Injectable()
export class AlgoHedgeConfigService extends BaseLookupService<
  string,
  CubiqTS.AlgoHedgeConfigInfoImpl
> {
  public _primed: PromiseSet<boolean> = new PrimaryPromiseSet<boolean>();

  constructor(protected cubiqWorker: CubiqWorker) {
    super(CubiqTS.AlgoHedgeConfigInfoImpl);
    this.initialize();
  }

  protected initialize(): void {
    let observable: Observable<CubiqTS.AlgoHedgeConfigInfoImpl[] | any> =
      this.cubiqWorker.primeStaticData<CubiqTS.AlgoHedgeConfigInfoImpl>(
        CubiqTS.AlgoHedgeConfigInfoImpl.name,
      );
    observable.subscribe(
      (values: CubiqTS.AlgoHedgeConfigInfoImpl[]) => {
        Promise.all([this.cubiqWorker.isAuth(`${this.constructor.name}`)]).then(() => {
          this.prime(values);
        });

        this.cubiqWorker
          .getEncodableObservable(CubiqTS.ModelUpdateImpl.name)
          .subscribe(this.processModelUpdateEvent.bind(this));
      },
      (error: Error) => {
        logger.out.error("Algo hedging defaults prime failed", error);
        this._primed.reject(error);
      },
      () => {
        this._primed.resolve(true);
      },
    );
  }

  protected processModelUpdateEvent(event: CubiqTS.ModelUpdateImpl): void {
    if (
      event == Object(event) &&
      event.payLoad == Object(event.payLoad) &&
      ((Array.isArray(this.lookupType) &&
        this.lookupType.some((type) => {
          event.payLoad instanceof type;
        })) ||
        (Array.isArray(this.lookupType) === false && event.payLoad instanceof this.lookupType))
    ) {
      let payload: CubiqTS.AlgoHedgeConfigInfoImpl =
        event.payLoad as CubiqTS.AlgoHedgeConfigInfoImpl;
      logger.out.info("Processing model update for algo hedging config of type ", event.eventType);

      if (event.eventType == CubiqTS.ModelUpdateType.DELETE) {
        this.deleteItem(payload);
      } else {
        this.mapItem(payload);
      }
    }
  }

  /**
   * Invokes platform to obtain default account profile mapping items for a given benchmark code
   * and fixing time. The method is invoked by the hedging order manager when positions are
   * hedged externally
   *
   * @param benchmarkCode the benchmark code
   * @param fixingTime the fixing time
   */
  public getDefaultAccountMappings(
    benchmarkCode: string,
    fixingTime: CubiqTS.Moment,
  ): Promise<CubiqTS.DefaultAccountProfileMappingImpl[]> {
    let request: CubiqTS.DefaultAccountProfileMappingRequestImpl =
      new CubiqTS.DefaultAccountProfileMappingRequestImpl();
    request.bmCode = benchmarkCode;
    request.fixingTime = fixingTime;
    return new Promise<CubiqTS.DefaultAccountProfileMappingImpl[]>((res, rej) => {
      this.cubiqWorker.postServiceRequest(request).then(
        (values: CubiqTS.StandardReportImpl) => {
          res(values.results);
        },
        (error: Error) => {
          logger.out.warn(
            "Failed to obtain default account mappings for benchmark code ",
            benchmarkCode,
            " and fixing time ",
            fixingTime,
          );
          rej(error);
        },
      );
    });
  }

  public getAlgoHedgeConfigByTraderGroup(
    traderGroupName: string,
  ): Array<CubiqTS.AlgoHedgeConfigInfoImpl> {
    return this.getAll().filter(
      (value: CubiqTS.AlgoHedgeConfigInfoImpl) => value.traderGroupNm == traderGroupName,
    );
  }

  public getItemKey(item: CubiqTS.AlgoHedgeConfigInfoImpl): string {
    return item.algoHedgeId.toString();
  }
}
